import { StartClient } from "@tanstack/react-start/client"
import { hydrateRoot } from "react-dom/client"
import { reactErrorHandler } from "@sentry/react"
import { initSentry } from "@/monitoring"

initSentry()

// React's own error channels, wired to Sentry so every report carries the
// component stack. Without these, anything React catches or recovers from
// only reaches Sentry as an anonymous console.error with a react-dom
// stacktrace — no component, no clue where in the UI it happened.
hydrateRoot(document, <StartClient />, {
  // Thrown outside any error boundary (this includes commit-phase DOM
  // failures, which no boundary can catch — they tear the root down)
  onUncaughtError: reactErrorHandler(),
  // Hydration mismatches and other errors React retried its way out of
  onRecoverableError: reactErrorHandler(),
  // onCaughtError is deliberately left alone: our Sentry ErrorBoundary
  // already reports what it catches, with the component stack attached.
})
